module.exports = __webpack_public_path__ + "static/media/_BID5588.a48154e5.png";